import mouse from "../../../../../input/mouse"
import ManaParticle from "../../../ManaParticle"
import InvertableManaNode, { InvertableManaNodeOptions } from "../../InvertableManaNode"
import NodeCategories from "../../NodeCategories"

export type DirectionMouseNodeOptions = {} & InvertableManaNodeOptions
export default class DirectionMouseNode extends InvertableManaNode {

	static nodeName = "Target cursor"
	static nodeDesc = "Sets particle direction towards the cursor"
	static nodeIcon = '🖱'
	static category = NodeCategories.Direction
	static nodeType = 'DirectionMouseNode'

	constructor({ inverted = false, ...rest }: DirectionMouseNodeOptions) {
		super({
			...rest,
			inverted
		})
	}

	onScroll(dir: number) { }

	async act(particle: ManaParticle) {
		if (particle.target) {
			particle.direction = mouse.position.clone().subtract(particle.target.position).norm()
			if (this.inverted) {
				particle.direction.rotateDeg(180)
			}
		}

		return true
	}

}